import { render, staticRenderFns } from "./icon-pencil.vue?vue&type=template&id=54a8d2ec&scoped=true&"
import script from "./icon-pencil.vue?vue&type=script&lang=js&"
export * from "./icon-pencil.vue?vue&type=script&lang=js&"
import style0 from "./icon-pencil.vue?vue&type=style&index=0&id=54a8d2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8d2ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
